<template>
  <div class="grade-comparison">
    <el-dialog
      title="多个考试学生成绩对比"
      :visible.sync="gradeComparisonShow"
      width="50%"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <div class="btn-list" v-show="isChooseContainerShow">
        <el-button type="primary" @click="selectTagStudent"
          >选择标签学生</el-button
        >
        <el-button type="primary" @click="selectClassStudent"
          >选择班级学生</el-button
        >
      </div>
      <!-- 上传成绩方式选择 -->
      <div v-show="!isChooseContainerShow">
        <tagStudent
          :isChooseContainerShow.sync="isChooseContainerShow"
          :labelConditionList="labelConditionList"
          :comparativeExamData="comparativeExamData"
          :gradeStudentList="gradeStudentList"
          v-show="selectionMode == 'tag'"
          @tagStudentSubmit="tagStudentSubmit"
          @searchLabelName="searchLabelName"
        />
        <classStudent
          :isChooseContainerShow.sync="isChooseContainerShow"
          :classStudentList="classStudentList"
          :gradeStudentList="gradeStudentList"
          :comparativeExamData="comparativeExamData"
          v-show="selectionMode == 'class'"
          @classStudentSubmit="classStudentSubmit"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tagStudent from "../tag-student/tagStudent.vue";
import classStudent from "../class-student/classStudent.vue";
export default {
  props: [
    "gradeComparisonShow",
    "labelConditionList",
    "comparativeExamData",
    "gradeStudentList",
    "classStudentList",
  ],
  components: {
    tagStudent,
    classStudent,
  },
  data() {
    return {
      selectionMode: "",
      isChooseContainerShow: true, // 为true时显示选择方式，为false根据selectionMode的值显示两种方式的一种:
    };
  },
  methods: {
    searchLabelName(e) {
      this.$emit("searchLabelName", e);
    },
    // 选择标签学生点击提交
    tagStudentSubmit(data) {
      this.post(this.$url.moreLabelStudentAvgScoreRankContrast, data).then(
        (res) => {
          // console.log("学生成绩对比选择标签方式==>", res);
          if (res.code !== 200)
            return this.$message.error(res.msg || "获取信息失败");
          this.$router.push({
            path: "/achievement-comparison",
            query: {
              studentList: res.data,
              comparativeExamData: this.comparativeExamData,
            },
          });
        }
      );
    },
    // 选择班级学生点击提交
    classStudentSubmit(data) {
      this.post(this.$url.moreStudentAvgScoreRankContrast, data).then((res) => {
        // console.log("选择班级学生点击提交==>", res);
        if (res.code !== 200)
          return this.$message.error(res.msg || "获取信息失败");
        this.$router.push({
          path: "/achievement-comparison",
          query: {
            studentList: res.data,
            comparativeExamData: this.comparativeExamData,
          },
        });
      });
    },
    // 开启弹窗
    dialogOpen() {
      this.isChooseContainerShow = true;
    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:gradeComparisonShow", false);
    },
    // 选择标签学生
    selectTagStudent() {
      this.isChooseContainerShow = false;
      this.selectionMode = "tag";
    },
    // 选择班级学生
    selectClassStudent() {
      this.isChooseContainerShow = false;
      this.selectionMode = "class";
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./gradeComparisonDialog.scss";
</style>